import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { UserService } from './services/user.service';
import { AdminService } from './services/admin.service';
import { environment } from '../environments/environment';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private userService: UserService,
    private adminService: AdminService
  ) {}

 canActivate(): Observable<boolean> {
  const user = this.userService.getUserInfo();

  if (environment.isPingEnable) {
    // Ping mode: require session token + Ping validation
    const token = sessionStorage.getItem('momaccesstoken');

    if (!token || !user) {
      this.router.navigate(['/loginping']); // Ping login page
      return of(false);
    }

    // Optional Ping user validation
    if (localStorage.getItem('isPingUser') === 'True') {
      return this.adminService.verifyPingAccessToken().pipe(
        map((result: any) => {
          if (!result?.active) {
            this.userService.logout();
            this.router.navigate(['/extlogin']);
            return false;
          }
          return true;
        }),
        catchError(() => {
          this.userService.logout();
          this.router.navigate(['/extlogin']);
          return of(false);
        })
      );
    }

    return of(true);

  } else {
    // Simple mode: only check if user info exists
    if (!user) {
      this.router.navigate(['/extlogin']); // Simple login page
      return of(false);
    }
    return of(true);
  }
}
}